/* eslint-disable react/prop-types */
import { connect, useSelector } from 'react-redux';
// import Rollbar from 'rollbar';
import { useSetLoading } from './common/hooks/appearance';

// import { env, rollbarAccessToken } from './config/env';

const Loader = connect((state) => {
  return {
    isLoading: state.appearance.isLoading,
  };
}, null)((props) => {
  if (props.isLoading) {
    return (
      <div className="loader-section">
        <div className="loader">
          <div />
          <div />
          <div />
        </div>
      </div>
    );
  }
  return null;
});

const App = ({ children }) => {
  const appDataLoading = useSelector((state) => state.appearance.appDataLoading);

  // Rollbar config disabled — was triggering continuous 429 errors
  // const rollbarConfig = {
  //   accessToken: rollbarAccessToken || '0ceb8259c22b4ee986246541c10917f4',
  //   captureUncaught: true,
  //   captureUnhandledRejections: true,
  //   payload: {
  //     environment: env,
  //   },
  //   scrubFields: ['ssn', 'cardnumber', 'cvc', 'postal'],
  // };

  useSetLoading(false);

  return (
    <>
      <Loader />
      {appDataLoading ? (
        <section className="login">
          <h3>Loading...</h3>
        </section>
      ) : (
        children
      )}
    </>
  );
};

export default App;
